import DefaultVendorCombined from './DefaultVendorCombined';

export default {
  line_items: [
    {
      lead_times: [1, 2, 3, 5],
      pricing: [
        [0, 0, 0, 0],
        [0, 0, 0, 0],
        [0, 0, 0, 0],
        [0, 0, 0, 0],
      ],
      quantities: [10, 25, 50, 100],
      product_key: 'fabrication-us-quickturn',
      quote_config_key: 'plx-grpb',
      options: {},
    },
    {
      lead_times: [1, 2, 3, 4, 5],
      pricing: [
        [0, 0, 0, 0, 0],
        [0, 0, 0, 0, 0],
        [0, 0, 0, 0, 0],
        [0, 0, 0, 0, 0],
      ],
      quantities: [10, 25, 50, 100],
      product_key: 'fabrication-us-excell',
      quote_config_key: 'excell-grpb',
      options: {},
    },
    {
      lead_times: [1, 2, 3, 4, 5],
      pricing: [
        [0, 0, 0, 0, 0],
        [0, 0, 0, 0, 0],
        [0, 0, 0, 0, 0],
        [0, 0, 0, 0, 0],
      ],
      quantities: [10, 25, 50, 100],
      product_key: 'fabrication-us-ampel',
      quote_config_key: 'ampel-grpb',
      options: {},
    },
    {
      lead_times: [1, 2, 3, 4, 5],
      pricing: [
        [0, 0, 0, 0, 0],
        [0, 0, 0, 0, 0],
        [0, 0, 0, 0, 0],
        [0, 0, 0, 0, 0],
      ],
      quantities: [10, 25, 50, 100],
      product_key: 'fabrication-offshore-whx',
      quote_config_key: 'whx-grpb',
      options: {},
    },
    {
      lead_times: [1, 2, 3, 4, 5],
      pricing: [
        [0, 0, 0, 0, 0],
        [0, 0, 0, 0, 0],
        [0, 0, 0, 0, 0],
        [0, 0, 0, 0, 0],
      ],
      quantities: [10, 25, 50, 100],
      product_key: 'fabrication-tw-offshore-jet-pcb',
      quote_config_key: 'jetpcb-grpb',
      options: {},
    },
  ],
  us_line_item_combined: DefaultVendorCombined,
};
